// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/abb3c63d652d6bf59e70.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"2cd2ee6cb344ff1b73f7","140":"d1c140c02da7afa3f242","141":"ddb3e2702966df3d0307"}[chunkId] + ".chunk.js";
};